
export const INIT       = 'init'
export const PROGRESS   = 'progress'
export const COMPLETED  = 'completed' 
export const SAVED      = 'saved' 
